module.exports = __webpack_public_path__ + "img/header.825f890d.png";